module.exports = __webpack_public_path__ + "22802bf1cfd0f364dcdf61a6c90ab30e.svg";